<template>
  <div class="progress-wrapper">
    <div class="progress-wrapper-inner">

      <span v-if="label" class="label">{{ label }}</span>
      <div class="progress-bar-container">

        <div class="progress-bar" :class="{ 'progress-bar--score': mode === 'score' }">
          <div class="progress-fill" :style="{ width: clamped + '%' }"></div>
        </div>
        <span class="percentage">
          <template v-if="detail"><span class="percentage-number">{{ clamped }}%</span>  {{ detail }}</template>
          <template v-else>{{ clamped }}%</template>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomepageProgress',
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: 'Progress',
    },
    /** e.g. "426/1121" — shown as "38% 426/1121" */
    detail: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'progress',
      validator: (v) => ['progress', 'score'].includes(v),
    },
    /** kept for backward compatibility; lock UI lives on the section card */
    locked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    clamped() {
      const n = Number(this.progress);
      if (!Number.isFinite(n) || n < 0) return 0;
      return Math.min(100, Math.round(n));
    },
  },
};
</script>

<style scoped>
.progress-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: transparent;
  color: white;
  padding: 0 10px;
  border-radius: 3px;
  font-family: Arial, sans-serif;
  font-size: 13px;
  width: 100%;
  box-sizing: border-box;
}
.progress-wrapper-inner {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.progress-bar-container {
  width: 100%;
}

.label {
  font-weight: bold;
  text-align: left;
  margin-bottom: 2px;
}

.progress-bar {
  flex: 1;
  height: 9px;
  background-color: transparent;
  border-radius: 10px;
  overflow: hidden;
  margin: 4px 0;
  border: 2px solid #ffffff;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.progress-fill {
  height: 100%;
  background-color: #9ded6c;
  transition: width 0.3s ease;
}

/* Score uses the same bar/track layout — only the fill color changes */
.progress-bar--score .progress-fill {
  background-color: #ed1c24;
}

.percentage {
  font-weight: 500;
  text-align: center;
  font-size: 12px;
  line-height: 1.2;
  font-family: 'Helveticacondensed';
}
span.percentage-number {
    padding-right: 5px;
    font-weight: 600;
}
</style>
